import { render, staticRenderFns } from "./UserProfileCoursesSection.vue?vue&type=template&id=01605104"
import script from "./UserProfileCoursesSection.vue?vue&type=script&lang=js"
export * from "./UserProfileCoursesSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports